import axios from 'axios'
import * as config from "./config.js"

/**
 * 获取建筑下的设备列表
 *
 * @param {*} buildingID
 * @returns
 */
function getAllBuildingDevice(buildingID) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: config.API.baseUrl + 'powerControl/getAllBuildingDevice',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'buildingID': buildingID
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 获取本月和上月的用电量
 *
 * @param {*} buildingID
 * @returns
 */
function getMonthUse(buildingID) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: config.API.baseUrl + 'powerControl/getMonthUse',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'buildingID': buildingID
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 修改建筑名称
 *
 * @param {*} buildingID
 * @param {*} buildingName
 * @returns
 */
function modifyBuildingName(buildingID, buildingName) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: config.API.baseUrl + 'powerControl/modifyBuildingName',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'buildingID': buildingID,
          'buildingName': buildingName
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 获取报警信息
 *
 * @param {*} buildingID
 * @returns
 */
function getAlarmInfo(buildingID) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: config.API.baseUrl + 'powerControl/getAlarmInfo',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'buildingID': buildingID
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 修改报警信息
 *
 * @param {*} buildingID
 * @param {*} alarmInfo
 * @returns
 */
function modifyAlarmInfo(buildingID, alarmInfo) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: config.API.baseUrl + 'powerControl/modifyAlarmInfo',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'buildingID': buildingID,
          'alarmInfo': alarmInfo
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 获取超过预警的电表
 *
 * @param {*} buildingID
 * @returns
 */
function getOverAlarmWatch(buildingID) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: config.API.baseUrl + 'powerControl/getOverAlarmWatch',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'buildingID': buildingID
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 获取用电前十名
 *
 * @param {*} buildingID
 * @param {*} startDate
 * @param {*} endDate
 * @returns
 */
function getTopUseEMeter(buildingID, startDate, endDate) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: config.API.baseUrl + 'powerControl/getTopUseEMeter',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'buildingID': buildingID,
          'startDate': startDate,
          'endDate': endDate
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 获取整栋大楼用电趋势
 *
 * @param {*} buildingID
 * @param {*} trendType
 * @returns
 */
function getBuildingUseTrend(buildingID, trendType) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: config.API.baseUrl + 'powerControl/getBuildingUseTrend',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'buildingID': buildingID,
          'trendType': trendType
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 获取建筑内所有电表的读数
 *
 * @param {*} buildingID
 * @param {*} startDate
 * @param {*} endDate
 * @param {*} page
 * @param {*} perPage
 * @returns
 */
function getBuildingEMeterValue(buildingID, startDate, endDate, page, perPage) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: config.API.baseUrl + 'powerControl/getBuildingEMeterValue',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'buildingID': buildingID,
          'startDate': startDate,
          'endDate': endDate,
          'page': page,
          'perPage': perPage
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 获取建筑内所有电表的读数
 *
 * @param {*} buildingID
 * @param {*} startDate
 * @param {*} endDate
 * @param {*} page
 * @param {*} perPage
 * @returns
 */

/**
 * 获取指定电表的数据
 *
 * @param {*} eMeterID
 * @returns
 */
function getEMeterInfo(eMeterID) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: config.API.baseUrl + 'powerControl/getEMeterInfo',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'eMeterID': eMeterID
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 修改指定电表的名称
 *
 * @param {*} eMeterID
 * @param {*} eMeterName
 * @returns
 */
function modifyEMeterName(eMeterID, eMeterName) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: config.API.baseUrl + 'powerControl/modifyEMeterName',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'eMeterID': eMeterID,
          'eMeterName': eMeterName
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 修改指定电表的地点
 *
 * @param {*} eMeterID
 * @param {*} eMeterLocation
 * @returns
 */
function modifyEMeterLocation(eMeterID, eMeterLocation) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: config.API.baseUrl + 'powerControl/modifyEMeterLocation',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'eMeterID': eMeterID,
          'eMeterLocation': eMeterLocation
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 开关电表
 *
 * @param {*} eMeterID
 * @param {*} operation
 * @returns
 */
function switchEMeter(eMeterID, operation) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: config.API.baseUrl + 'powerControl/switchEMeter',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'eMeterID': eMeterID,
          'operation': operation
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 获取指定电表的用电趋势
 *
 * @param {*} eMeterID
 * @param {*} trendType
 * @returns
 */
function getEmeterUseTrend(eMeterID, trendType) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: config.API.baseUrl + 'powerControl/getEmeterUseTrend',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'eMeterID': eMeterID,
          'trendType': trendType
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 获取指定电表的读数
 *
 * @param {*} eMeterID
 * @param {*} startDate
 * @param {*} endDate
 * @returns
 */
function getEMeterValue(eMeterID, startDate, endDate) {
  return new Promise(function (resolve, reject) {
    axios({
        method: 'post',
        url: config.API.baseUrl + 'powerControl/getEMeterValue',
        headers: {
          'Content-Type': 'application/json',
          'password': '95951a18-5a9e-da26-ad13-64dcc6e11208'
        },
        data: {
          'eMeterID': eMeterID,
          'startDate': startDate,
          'endDate': endDate
        }
      })
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

/**
 * 格式化电表读数
 * 3.14  =》  00000314
 *
 * @param {*} initValue
 * @returns
 */
function formatEMeterValue(initValue) {
  let formatValue = '';
  if (initValue < 1) {
    initValue = initValue * 100;
    formatValue = '' + initValue;
    formatValue = formatValue.slice(0, 2);
  } else {
    initValue = initValue * 100;
    formatValue = '' + initValue;
  }
  let formatValueArray = formatValue.split('.');
  formatValue = formatValueArray[0];

  let length = formatValue.length;
  let zeroLength = 8 - length;

  for (let i = 0; i < zeroLength; i++) {
    formatValue = '0' + formatValue;
  }

  return (formatValue);
}

export {
  getAllBuildingDevice,
  getMonthUse,
  modifyBuildingName,
  getAlarmInfo,
  modifyAlarmInfo,
  getOverAlarmWatch,
  getTopUseEMeter,
  getBuildingUseTrend,
  getBuildingEMeterValue,
  getEMeterInfo,
  modifyEMeterName,
  modifyEMeterLocation,
  switchEMeter,
  getEmeterUseTrend,
  getEMeterValue,
  formatEMeterValue
}



//////////////////
// WEBPACK FOOTER
// ./static/js/powerControl.js
// module id = Sk9P
// module chunks = 1